export default {
  id: 'healthHistory/SOCIO_ECONOMIC_DATA/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.socioEconomicData',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.socioEconomicData',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
